<template>
    <nav class="calc-nav">
        <div class="calc-nav__logo-wrap">
            <img
                src="/calculator-assets/linxfour-logo.png"
                :alt="$t('§calc.nav.logo_alt')"
                class="calc-nav__logo"
                :title="$t('§calc.nav.logo_title')"
                @click="$emit('logo')"
            />
        </div>
        <CalcStepper
            :current-step="currentStep"
            :max-reached="maxReached"
            @step-click="$emit('navigate', $event)"
        />
        <div class="calc-nav__close-wrap">
            <button
                type="button"
                class="calc-nav__close"
                :aria-label="$t('§calc.nav.exit_aria')"
                @click="$emit('exit')"
            >
                <CalcIcon name="close" />
            </button>
        </div>
    </nav>
</template>

<script>
import CalcIcon from './CalcIcon.vue'
import CalcStepper from './CalcStepper.vue'

export default {
    name: 'CalcNav',

    components: { CalcIcon, CalcStepper },

    props: {
        currentStep: {
            type: Number,
            required: true,
        },
        maxReached: {
            type: Number,
            default: null,
        },
    },

    emits: ['exit', 'navigate', 'logo'],
}
</script>

<style scoped>
.calc-nav {
    position: relative;
    z-index: 5;
    height: 80px;
    padding: 0 26px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 24px;
}

.calc-nav__logo-wrap {
    justify-self: start;
}

.calc-nav__close-wrap {
    justify-self: end;
}

.calc-nav__logo {
    height: 42px;
    width: auto;
    display: block;
    cursor: pointer;
    background: transparent;
    transition: opacity var(--calc-t-fast);
}

.calc-nav__logo:hover {
    opacity: 0.7;
}

.calc-nav__close {
    width: 48px;
    height: 48px;
    border-radius: 100px;
    display: grid;
    place-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--calc-ink);
    transition:
        background var(--calc-t-fast),
        transform var(--calc-t-fast);
}

.calc-nav__close:hover {
    background: rgba(4, 15, 15, 0.08);
}

.calc-nav__close:active {
    transform: scale(0.94);
}

@media (max-width: 760px) {
    .calc-nav {
        padding: 0 16px;
        height: 64px;
        gap: 12px;
        grid-template-columns: auto 1fr auto;
    }
    .calc-nav__logo {
        height: 30px;
    }
}
</style>
